import type { Data, DataGroupItem } from "./ButtonSelect";

export const isDataGroupItemGroup = (data?: Data): data is DataGroupItem[] =>
  Boolean(
    data && data.length > 0 && typeof data[0] !== "string" && "group" in data[0]
  );
